var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base"},[_c('default-top-bar'),_c('default-side-bar'),_c('default-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }